import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

/**
 * Social share row.
 * WhatsApp, X (Twitter), Facebook, LinkedIn, Copy Link — one-tap share.
 */
const ShareButtons = ({ title, url }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const encoded = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title || '');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      // fallback
      const input = document.createElement('input');
      input.value = shareUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const btn =
    'flex items-center gap-2 px-3 py-2 rounded-full border border-gray-200 text-xs font-semibold text-[#1B1B1B] hover:bg-[#3D4A26] hover:text-white hover:border-[#3D4A26] transition-colors';

  return (
    <div className="my-8 py-6 border-y border-gray-200" data-testid="share-buttons">
      <p className="text-xs uppercase tracking-widest font-semibold text-gray-500 mb-3">Bu yazıyı paylaş</p>
      <div className="flex flex-wrap items-center gap-2">
        <a
          data-testid="share-whatsapp"
          className={btn}
          href={`https://api.whatsapp.com/send?text=${encodedTitle}%20${encoded}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp'ta paylaş"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2m0 18.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31c-.82-1.31-1.26-2.83-1.26-4.38 0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.23 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.17.25-.64.81-.79.98-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.37-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.42-.14-.01-.31-.01-.48-.01s-.43.06-.66.31c-.22.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.13.17 1.76 2.68 4.26 3.76.6.26 1.06.41 1.42.53.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29" />
          </svg>
          WhatsApp
        </a>

        <a
          data-testid="share-twitter"
          className={btn}
          href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encoded}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X (Twitter) üzerinde paylaş"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2H21l-6.545 7.478L22 22h-6.828l-5.36-6.9L3.6 22H.844l7.005-8.005L1.5 2h6.914l4.83 6.31L18.244 2Zm-2.398 18h1.883L7.243 4H5.223l10.623 16Z" />
          </svg>
          X (Twitter)
        </a>

        <a
          data-testid="share-facebook"
          className={btn}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encoded}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook'ta paylaş"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
          </svg>
          Facebook
        </a>

        <button
          type="button"
          onClick={handleCopy}
          data-testid="share-copy"
          className={btn}
          aria-label="Bağlantıyı kopyala"
        >
          {copied ? <Check size={14} /> : <Copy size={14} />}
          {copied ? 'Kopyalandı' : 'Bağlantıyı Kopyala'}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
